import React, { useState, useEffect } from 'react';
import { isEmpty } from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import SystemMasterTabel from '../../Components/SystemMasterTabel/SystemMasterTabel';
import * as action from './Store/SystemMasters.action';
import ConfirmationPopup from '../../Components/ModalPopup/ConfirmationPopup';
import { useComponent } from '../UserSetting/UsersLibrary/UserRights';

const tempObj = {
  name: null,
  isEmpty: false,
  isNew: true,
  isActive: true,
  hasLength: false,
  _id: '',
};

function Category1Master() {
  const dispatch = useDispatch();
  const reducer = useSelector((estate) => estate);
  const {
    SystemMastersDetails: { category1List, userAccessCategories1, pcTypeList },
    UserDetails: { userInfo },
    Users: { logInRights },
  } = reducer;
  const { CheckActionPermission } = useComponent();

  const MasterAddEditAccess = CheckActionPermission(logInRights, 'masters', 'category', 'addEdit');
  const MasterDeleteAccess = CheckActionPermission(logInRights, 'masters', 'category', 'delete');
  const { t } = useTranslation('common');
  const loggedInUserId = userInfo.userId;
  const loggedInUserRole = userInfo.role;

  const [isLoadingCat1, setIsLoadingCat1] = useState(false);
  const [showCat1, setShowCat1] = useState(false);
  const [isCategory1Unique, setIsCategory1Unique] = useState(true);
  const [buttonDownCat1, setButtonDownCat1] = useState(true);
  const [cat1BtnDisable, setCat1BtnDisable] = useState(false);
  const [addingCat1, setAddingCat1] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [showConfirmationAD, setShowConfirmationAD] = useState(false);
  const [isLoadingConf, setIsLoadingConf] = useState(false);
  const [isCat1, setIsCat1] = useState(false);
  const [cat1Data, setCat1Data] = useState([]);
  const [isUniqCat1Id, setIsUniqCat1Id] = useState([]);
  const [allowedcategoriesId, setAllowedCategoriesId] = useState([]);
  const [deleteId, setDeleteId] = useState('');
  const [activeInactiveID, setActiveInactiveID] = useState('');
  const [catBasedOnPTData, setCatBasedOnPTData] = useState(false);

  useEffect(() => {
    if (userAccessCategories1 && !isEmpty(userAccessCategories1)) {
      setAllowedCategoriesId(userAccessCategories1?.map((element) => element?._id));
    }
  }, [userAccessCategories1]);

  useEffect(() => {
    const fetchCatBasedOnPTData = async () => {
      const catBasedOnPTRes = await dispatch(action.getCatBasedOnPT());
      setCatBasedOnPTData(catBasedOnPTRes);
    };
    fetchCatBasedOnPTData();
  }, [dispatch]);

  // Ensure fresh data on initial mount (helps after redirects or when redux cache is stale)
  useEffect(() => {
    (async () => {
      const cat1Params = {
        accessedFrom: 'masters',
        categoryType: 1,
        loggedInUserId,
        includeInactive: true,
      };
      if (loggedInUserRole === 'User') {
        cat1Params.isMaster = true;
        dispatch(action.getuserCategoriesDetails({ type: 1 }));
      }
      await dispatch(action.getCategory1Details(cat1Params));
      if (isEmpty(pcTypeList)) {
        await dispatch(action.getPCTypesDetails({ includeInactive: true }, true));
      }
    })();
  }, [dispatch, loggedInUserId, loggedInUserRole, pcTypeList]);

  useEffect(() => {
    setCat1Data(category1List);
    if (addingCat1) {
      setCat1Data([
        ...category1List,
        {
          name: null,
          isEmpty: false,
          isNew: true,
          isActive: true,
          _id: '',
          aliasName: '',
        },
      ]);
    }
  }, [category1List, addingCat1]);

  const callApi = async () => {
    setButtonDownCat1(!buttonDownCat1);
    setIsLoadingCat1(true);
    buttonDownCat1 ? setShowCat1(true) : setShowCat1(false);
    const cat1Params = {
      accessedFrom: 'masters',
      categoryType: 1,
      loggedInUserId,
      includeInactive: true,
    };
    // Always refresh to avoid stale data after redirect/time
    if (loggedInUserRole === 'User') {
      cat1Params.isMaster = true;
      dispatch(action.getuserCategoriesDetails({ type: 1 }));
    }
    await dispatch(action.getCategory1Details(cat1Params));
    if (isEmpty(pcTypeList)) await dispatch(action.getPCTypesDetails({ includeInactive: true }, true));
    setIsLoadingCat1(false);
  };

  const handleChanged = (event, i) => {
    const categories1 = [...cat1Data];
    setIsCategory1Unique(true);
    setIsUniqCat1Id([]);
    if (event.target.name === 'aliasName') {
      categories1[i] = {
        ...categories1[i],
        aliasName: event.target.value,
      };
    } else {
      categories1[i] = {
        ...categories1[i],
        name: event.target.value,
        isEmpty: event.target.value === '',
      };
    }
    const arr = [];
    const arrIndex = [];
    categories1.forEach((ele, ind) => {
      categories1.forEach((objs, index) => {
        if (ele.name === objs.name && ind !== index) {
          arr.push(ele);
          arrIndex.push(index);
        }
      });
    });
    if (!isEmpty(arr)) {
      const arrs = [...arrIndex];
      const removeArss = Math.min(...arrs);
      const newArr = arrIndex.filter((ele) => ele !== removeArss);
      setIsUniqCat1Id([...newArr]);
    }
    setIsCategory1Unique(isEmpty(arr));
    let isDisableCat1 = false;
    categories1.forEach((category1Element) => {
      if (isEmpty(category1Element?.name?.trim())) {
        isDisableCat1 = true;
      }
    });
    setCat1BtnDisable(isDisableCat1);
    setCat1Data(categories1);
  };

  const addCat1 = async () => {
    if (!showCat1) {
      setAddingCat1(true);
      setButtonDownCat1(!buttonDownCat1);
      setIsLoadingCat1(true);
      buttonDownCat1 ? setShowCat1(true) : setShowCat1(false);
      const cat1Params = {
        accessedFrom: 'masters',
        categoryType: 1,
        loggedInUserId,
      };
      if (loggedInUserRole === 'User') {
        cat1Params.isMaster = true;
        dispatch(action.getuserCategoriesDetails({ type: 1 }));
      }
      isEmpty(cat1Data) && (await dispatch(action.getCategory1Details(cat1Params)));
      setIsLoadingCat1(false);
    } else if (!isEmpty(cat1Data)) {
      setCat1Data([...cat1Data, tempObj]);
    } else {
      setCat1Data([tempObj]);
    }
  };
  const handleDelete = (id) => {
    if (typeof id === 'number' || id === '') {
      cat1Data.splice(id, 1);
      cat1Data.forEach((category1Element) => {
        if (isEmpty(category1Element?.name?.trim()) && category1Element.isNew) {
          setCat1BtnDisable(true);
        } else {
          setCat1BtnDisable(false);
        }
      });
      setIsUniqCat1Id([]);
      setIsCategory1Unique(true);
      setCat1Data([...cat1Data]);
    } else {
      setDeleteId(id);
      setShowConfirmation(true);
    }
  };

  const saveCat1 = async () => {
    setIsCat1(true);
    if (!isEmpty(cat1Data)) {
      const emptyField = cat1Data.filter((c1item) => {
        const nameMissing = c1item.name === null || c1item.name === '';
        const ptMissing = !Array.isArray(c1item?.productType) || c1item.productType.length === 0;
        return catBasedOnPTData ? nameMissing || ptMissing : nameMissing;
      });
      if (isEmpty(emptyField)) {
        const data = cat1Data.map((ca1obj) => {
          const normalizedPT = Array.isArray(ca1obj?.productType)
            ? ca1obj.productType
                .map((type) => (type && typeof type === 'object' ? type?.value ?? type?._id ?? null : type))
                .filter((v) => v !== null && v !== undefined)
            : [];

          const next = {
            ...ca1obj,
            name: ca1obj?.name?.trim(),
            aliasName: ca1obj?.aliasName ? ca1obj.aliasName.trim() : '',
          };
          if (catBasedOnPTData) {
            next.productType = normalizedPT;
          } else {
            delete next.productType;
          }
          return next;
        });
        const cat1DeleteParams = {
          loggedInUserId,
          categoriesName: JSON.stringify(data),
          categoryType: 1,
          title: t('CATEGORY1.CATEGORIESS'),
          showAlias: true,
        };
        setAddingCat1(false);
        await dispatch(action.saveToSystemMaster(cat1DeleteParams, t));
        const cat1Params = {
          accessedFrom: 'masters',
          categoryType: 1,
          loggedInUserId,
        };
        if (loggedInUserRole === 'User') {
          cat1Params.isMaster = true;
          dispatch(action.getuserCategoriesDetails({ type: 1 }));
        }
        await dispatch(action.getCategory1Details(cat1Params));
        // post API
      } else {
        const newState = cat1Data.map((c1obj) => {
          const nameMissing = c1obj.name === null || c1obj.name === '';
          const ptMissing = !Array.isArray(c1obj?.productType) || c1obj.productType.length === 0;
          const shouldFlag = catBasedOnPTData ? nameMissing || ptMissing : nameMissing;
          return !c1obj?.isEmpty && shouldFlag ? { ...c1obj, isEmpty: true } : c1obj;
        });
        setCat1Data(newState);
      }
    }
    setIsCat1(false);
  };

  const activeInactiveClicked = (id) => {
    setShowConfirmationAD(true);
    setActiveInactiveID(id);
  };

  const handleProductTypesChange = (selectedValues, index) => {
    const updatedCat1Data = [...cat1Data];
    const nextSelected = Array.isArray(selectedValues) ? selectedValues : [];
    updatedCat1Data[index] = {
      ...updatedCat1Data[index],
      productType: nextSelected,
      isEmpty: nextSelected.length === 0,
    };
    setCat1Data(updatedCat1Data);
  };

  useEffect(() => {
    const array = [];
    cat1Data?.forEach((ele, index) => {
      cat1Data?.forEach((obj, places) => {
        if (index !== places && ele?.name === obj?.name) {
          array.push(ele);
        }
      });
    });
    if (isEmpty(array)) {
      setIsCategory1Unique(isEmpty(array));
      setIsUniqCat1Id([]);
    }
  }, [cat1Data]);

  const deleteConfirmed = async () => {
    setIsLoadingConf(true);
    const category1Params = {
      categoryType: 1,
      loggedInUserId,
      wantToDeleteCategoryId: deleteId,
      title: t('CATEGORY1.CATEGORIES'),
    };
    await dispatch(action.deleteFromSystemMasters(category1Params, t));
    setIsLoadingConf(false);
    setShowConfirmation(false);
    setCat1Data([...category1List]);
    const cat1Params = {
      accessedFrom: 'masters',
      categoryType: 1,
      loggedInUserId,
    };
    if (loggedInUserRole === 'User') {
      cat1Params.isMaster = true;
      dispatch(action.getuserCategoriesDetails({ type: 1 }));
    }
    await dispatch(action.getCategory1Details(cat1Params));
  };

  const activeInactiveConfirmed = async () => {
    setIsLoadingConf(true);
    let c1 = {};
    cat1Data.forEach((ele) => {
      if (ele._id === activeInactiveID) {
        ele.isActive = !ele.isActive;
        const data = {
          ...ele,
          loggedInUserId,
          title: t('CATEGORY1.CATEGORIES'),
        };
        c1 = data;
      }
    });
    await dispatch(action.setActiveInactive(c1, t));
    setIsLoadingConf(false);
    setShowConfirmationAD(false);
    setCat1Data([...cat1Data]);
  };

  return (
    <>
      <SystemMasterTabel
        isLoading={isLoadingCat1}
        setShow={showCat1}
        callApi={callApi}
        buttonDown={buttonDownCat1}
        mainData={cat1Data}
        handleChanged={handleChanged}
        addBtnClicked={addCat1}
        deletPressed={handleDelete}
        onSave={saveCat1}
        isDesabled={isCat1}
        addLimit
        title={t('CATEGORY1.TITLE')}
        masterAddEditAccess={MasterAddEditAccess}
        masterDeleteAccess={MasterDeleteAccess}
        inputName="category1"
        activeInactiveClicked={activeInactiveClicked}
        btnDisable={cat1BtnDisable}
        isUnique={isCategory1Unique}
        isUniqueId={isUniqCat1Id}
        allowedIds={allowedcategoriesId}
        showAlias
        productTypeOptions={pcTypeList}
        onChangeProductTypes={handleProductTypesChange}
        placeholder="Enter Category 1"
        catBasedOnPTData={catBasedOnPTData}
      />
      {showConfirmation && (
        <ConfirmationPopup
          onOpen={showConfirmation}
          onConfirm={() => deleteConfirmed()}
          title={t('CATEGORY1.DELETE_CONFIRM_TITLE')}
          message={t('CATEGORY1.DELETE_CONFIRM_MESSAGE')}
          toggle={() => setShowConfirmation(!showConfirmation)}
          loading={isLoadingConf}
        />
      )}
      {showConfirmationAD && (
        <ConfirmationPopup
          onOpen={showConfirmationAD}
          onConfirm={() => activeInactiveConfirmed()}
          title={t('CATEGORY1.ACTIVATE_DEACTIVATE_CONFIRM_TITLE')}
          message={t('CATEGORY1.ACTIVATE_DEACTIVATE_CONFIRM_MESSAGE')}
          toggle={() => setShowConfirmationAD(!showConfirmationAD)}
          loading={isLoadingConf}
        />
      )}
    </>
  );
}
export default Category1Master;
